// Demo mode is only reachable when the local developer explicitly sets
// REACT_APP_ENABLE_DEMO_MODE=true. Production builds never use these client-
// side preview identities, even when Supabase configuration is missing.

import { ROLES } from "./roles";

const DEMO_KEY = "daycare.demo.session.v1";

export const DEMO_USERS = {
  [ROLES.PARENT]: {
    id: "demo-parent",
    email: "parent@daycare.test",
    full_name: "Rivka Cohen",
    role: ROLES.PARENT,
  },
  [ROLES.TEACHER]: {
    id: "demo-teacher",
    email: "teacher@daycare.test",
    full_name: "Amara Johnson",
    role: ROLES.TEACHER,
  },
  [ROLES.ADMIN]: {
    id: "demo-admin",
    email: "admin@daycare.test",
    full_name: "Priya Mehta",
    role: ROLES.ADMIN,
  },
  [ROLES.CMS_EDITOR]: {
    id: "demo-cms",
    email: "cms@daycare.test",
    full_name: "Luca Ricci",
    role: ROLES.CMS_EDITOR,
  },
};

export function readDemoSession() {
  try {
    const raw = localStorage.getItem(DEMO_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeDemoSession(session) {
  localStorage.setItem(DEMO_KEY, JSON.stringify(session));
}

export function clearDemoSession() {
  localStorage.removeItem(DEMO_KEY);
}
